import React from 'react';
import { IoChatbubbleSharp } from 'react-icons/io5';
import { lazyPage } from '../lazyPage';

const ConversationListPage = lazyPage(() => import(/* webpackChunkName: "m-conversations" */ './pages/ConversationListPage'));
const ConversationDetailPage = lazyPage(() => import(/* webpackChunkName: "m-conversations" */ './pages/ConversationDetailPage'));
const ConversationDashboardPage = lazyPage(() => import(/* webpackChunkName: "m-conversations" */ './pages/ConversationDashboardPage'));

/**
 * Conversation feature manifests — WRAP the existing routes only. This file is
 * additive; features/conversation internals are another dev's active domain and
 * are not modified. Two manifests because the inboxes are gated by two different
 * feature keys. Route elements, paths, and icons are identical to the previous
 * App.js / NavigationBar declarations.
 */
const conversationManifests = [
    // NOTE: the 'gpt-chat' (Farm GPT monitor) manifest was folded into the unified
    // Inbox (features/inbox) — FarmGPT is now the "farmgpt" channel there. Its
    // read-only monitor components, hooks, and apis/users-chats have been deleted.
    // Agronomist stays below.
    {
        id: 'agro-chat',
        featureName: 'agroChat_mgmt',
        permission: 'view',
        routes: [
            { path: '/agro-chats', element: <ConversationListPage /> },
            { path: '/users-chat', element: <ConversationDetailPage /> },
            { path: '/users-dashboard', element: <ConversationDashboardPage /> },
        ],
        sidebarItems: [{ text: 'Org Chats', icon: <IoChatbubbleSharp />, link: '/agro-chats' }],
    },
];

export default conversationManifests;
